const firebaseConfig = {
    apiKey: "AIzaSyAPm2P7awgLpKago9ISxH5r0bxhYeoK_XU",
    authDomain: "trust-courier.firebaseapp.com",
    projectId: "trust-courier",
    storageBucket: "trust-courier.appspot.com",
    messagingSenderId: "642115943065",
    appId: "1:642115943065:web:29dd4544e5d9f231d9d608"
  };
  export default firebaseConfig;